import React from 'react';

export interface IThemeContext {
    darkMode: boolean
    changeTheme?: any
}

export const ThemeContext = React.createContext<IThemeContext>({
    darkMode: false,
    changeTheme: () => {}
});